var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"User/form","endpoint":"users","aditionalColumns":_vm.headers,"inlineToggle":""}},[[_c('h1',[_vm._v("Cadastro de Usuários")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }